import { useBadgingTranslation } from '../../../../ui/hooks';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Stack, Typography } from '@mui/material';
import React from 'react';
export const AccountBadgeStatusLabel = ({ status, statusReasonTitle }) => {
    const { t } = useBadgingTranslation();
    return (React.createElement(Stack, { direction: 'row', gap: 1, alignItems: 'center' },
        status === 'valid' ? (React.createElement(CheckCircleIcon, { sx: { color: themeColors.accent.green.base } })) : (React.createElement(CancelIcon, { sx: { color: themeColors.accent.red.base } })),
        React.createElement(Typography, { variant: 'body2', sx: { wordBreak: 'break-word' } }, status === 'revoked'
            ? t(`badges.badgeDetails.accountBadgeTable.statusLabels.revoked`, {
                revokeReason: statusReasonTitle,
            })
            : t(`badges.badgeDetails.accountBadgeTable.statusLabels.${status}`))));
};
